<template>
  <div>
    <Popup v-if="current === 'Comfirm'" size="md" :alert-btn="false" @close="$emit('close')">
      {{ description }}
      <div class="mt-3">
        <button
          v-if="allowResetPassword"
          class="mx-1 btn btn-sm rounded-pill"
          :class="{'btn-light': !alreadyExpired, 'btn-primary': alreadyExpired}"
          @click="current = 'Form'"
        >
          <span class="px-3">{{ $t('changePassword.form.submit') }}</span>
        </button>
        <button v-if="data.allowLogin" class="mx-1 btn btn-sm btn-primary rounded-pill" @click="$emit('login')">
          <span class="px-3">{{ $t('common.confirm') }}</span>
        </button>
      </div>
    </Popup>
    <ChangePassword v-if="current === 'Form'" :user="user" @close="$emit('close')" />
  </div>
</template>
<script>
import Popup from '@/components/Popup.vue';
import ChangePassword from '@/components/Login/ChangePassword.vue';

export default {
  components: {
    Popup,
    ChangePassword
  },
  props: ['data'],
  data() {
    return {
      current: 'Comfirm'
    };
  },
  computed: {
    allowResetPassword() {
      return (this.data.tempToken || '') !== '';
    },
    alreadyExpired() {
      const current = new Date().getTime();
      return current > this.data.expired;
    },
    description() {
      if (this.alreadyExpired) {
        return this.$t('login.messages.passwordExpired');
      }

      const date = new Date(this.data.expired);
      const params = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        date: date.getDate(),
        hour: date.getHours(),
        minute: date.getMinutes(),
        second: date.getSeconds()
      };
      return this.$t('login.messages.passwordExpiredNotify', params);
    },
    user() {
      return {
        account: this.data.account,
        token: this.data.tempToken
      };
    }
  },
  methods: {
  }
};
</script>
